import isLocalStorageAvailable from "./isLocalStorageAvailable";

export function getLocalStorageValue(key, fallbackValue) {
    if (isLocalStorageAvailable()) {
        return localStorage.getItem(key) || fallbackValue;
    }
    return fallbackValue;
}


export function setLocalStorageValue(key, value) {
    if (isLocalStorageAvailable()) {
        return localStorage.setItem(key, value);
    }
}

export function removeLocalStorageValue(key) {
    if (isLocalStorageAvailable()) {
        return localStorage.removeItem(key);
    }
}